 <template>
  <v-card>
    <v-card-title class="headline grey lighten-2" primary-title>
      Payer's Cheque No.
      <v-spacer></v-spacer>
      <v-btn text icon @click="closeDialog">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-card-title>
    <v-card-text>
      <v-flex xs12>
        <form data-vv-scope="queryPayersChequeNoFilterForm">
          <v-expansion-panels>
            <v-expansion-panel>
              <v-expansion-panel-header>
                <div><v-icon>mdi-filter-variant</v-icon> Filters</div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-card>
                  <v-card-text>
                    <v-container fluid grid-list-sm>
                      <v-layout row wrap>
                        <v-flex lg6 xs12>
                          <v-text-field
                            data-vv-scope="queryPayersChequeNoFilterForm"
                            v-model="filtersPayersChequeNo.payersChequeNo"
                            :label="filtersPayersChequeNoLabel.payersChequeNo"
                            :error-messages="errors.collect('filterPayersChequeNo')"
                            data-vv-name="filterPayersChequeNo"
                            :data-vv-as="filtersPayersChequeNoLabel.payersChequeNo"
                            v-validate="'entry|max:20'"
                          ></v-text-field>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-card-text>
                  <v-card-actions right>
                    <v-spacer></v-spacer>
                    <v-btn color="red darken-1" text @click.native="doClearPayersChequeNoFilters(true)">Clear Filters</v-btn>
                    <v-btn color="primary" text @click.prevent="doPayersChequeNoFilters">Apply Filters</v-btn>
                  </v-card-actions>
                </v-card>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </form>
      </v-flex>
      <v-flex xs12 class="mt-2">
        <v-data-table
          :headers="payersChequeNoHeaders"
          :items="payersChequeNoItems"
          v-bind:options.sync="paginationPayersChequeNo"
          :footer-props="{'items-per-page-options': itemsPerPage }"
          :server-items-length="totalItemsPayersChequeNo"
          :loading="loading"
          class="elevation-1"
          :no-data-text="noDataText"
        >
          <template v-slot:item="row"
            ><tr>
              <td>{{ row.item.payrChqNo }}</td>
              <td style="text-align: center">
                <v-btn text icon color="primary" type="submit" @click.prevent="assignPayersCheq(row.item)">
                  <v-icon>mdi-content-copy</v-icon>
                </v-btn>
              </td>
            </tr></template
          >
        </v-data-table>
      </v-flex>
    </v-card-text>
  </v-card>
</template>

<script>
import * as TableConst from '@/mixins/table'
import { accountsFilters } from '@/mixins/accounting/accountsFilters'
import { commonAjaxMixin } from '@/mixins/common/commonAjaxMixin'

export default {
  data() {
    return {
      actionName: '',
      paginationPayersChequeNo: {
        page: 1
      }
    }
  },
  mounted() {
  },
  watch: {
    boolRefresh: function (value) {
      if (value) {
        this.doClearPayersChequeNoFilters()
      }
    },
    'paginationPayersChequeNo': function(value) {
      this.doClearPayersChequeNoFilters()
    }
  },
  methods: {
    closeDialog() {
      this.filtersPayersChequeNo.payersChequeNo = ''
      this.$emit('close')
    },
    doClearPayersChequeNoFilters(toClear) {
      if (toClear === true) {
        this.filtersPayersChequeNo.payersChequeNo = ''
      }
      this.fetchPayersChequeNoData()
    },
    doPayersChequeNoFilters() {
      this.resetMessages()
      this.$validator.validateAll('queryPayersChequeNoFilterForm').then((result) => {
        if (result) {
          this.paginationPayersChequeNo.page = 1
          this.fetchPayersChequeNoData()
        }
      })
    },
    assignPayersCheq(data) {
      // Use $emit to call parent Accounts page method assignPayerCheq and pass the value
      this.$emit('assign-payers-cheq', data.payrChqNo)
      this.$emit('close')
    }
  },
  computed: {},
  props: {
    boolRefresh: {
      type: Boolean,
      default: true
    }
  },
  mixins: [TableConst.default, accountsFilters, commonAjaxMixin]
}
</script>
